/**
 * DataBest — Auth API client.
 * Thin wrapper around axios; each function returns the raw response payload.
 */
import api from "@/lib/axios";

export const authApi = {
    login: (email, password) =>
        api.post("/auth/login", { email, password }).then((r) => r.data),
    me: () => api.get("/auth/me").then((r) => r.data),
    refresh: (refresh_token) =>
        api.post("/auth/refresh", { refresh_token }).then((r) => r.data),
    logout: () => api.post("/auth/logout").then((r) => r.data),
    changePassword: (current_password, new_password) =>
        api
            .post("/auth/change-password", { current_password, new_password })
            .then((r) => r.data),
};

export default authApi;
